import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import {getNorthCitiesIds} from "@models/area";
import Selection from "@molecules/selection/selection";
import {Container as SelectionLists} from "@molecules/selection/components/lists";
import {FilterDispatcherContext} from "@providers/filters";
import {UpdateSelectionOptions} from "@hooks/selection.options";
import {useWindowSize} from "@helpers/windows.size";
import {CheckboxGroupBox, CheckboxGroupLabel, CheckboxLabelTitle} from "@atoms/checkbox.list.group";
import {isEmpty} from "@helpers/helpers";
import {inArray} from "@helpers/arrays";

function TypesSelection({items, loading, city_id, className, name, showLabelAndSelected}) {
    const windowSize = useWindowSize();
    const filterDispatcher = React.useContext(FilterDispatcherContext);
    const {options, selected_items} = items;
    const selectedItemsCopy = [...selected_items];

    const [northCitiesIds, setNorthCitiesIds] = useState([]);

    function handleChange(data) {
        if (JSON.stringify(data.items) !== JSON.stringify(selectedItemsCopy)) {
            const new_option = UpdateSelectionOptions(options, data);
            filterDispatcher({
                type: 'TYPES_OPTIONS',
                payload: new_option
            });
        }
    }

    useEffect(() => {
        if (!northCitiesIds.length) {
            getNorthCitiesIds().then(ids => {
                setNorthCitiesIds(ids);
            })
        }
    }, [city_id]);

    let selectionType = (!isEmpty(city_id) && (inArray(city_id, northCitiesIds) || inArray(city_id, [207, 259]))) ? 'single' : 'multiple';

    return (
        <Container className={typeof className !== "undefined" ? className : ''}>
            <Selection
                type={selectionType}
                name={name ?? "type"}
                options={options}
                selected_items={selected_items}
                label="نوع ملک"
                caption_show={2}
                onChange={(data) => handleChange(data)}
                select_optional={(windowSize < 768)}
                showLabelAndSelected={!!(showLabelAndSelected)}
                loading={(!isEmpty(loading) && loading)}
            />
        </Container>
    )
}

export default TypesSelection;

// styles
const Container = styled.div`
    ${SelectionLists} {
        &:not(.single) {
            display: flex;
            flex-wrap: wrap;
        }
        
        @media (max-width: ${props => props.theme.screenXsMax}) {
            padding-top: 0;
            margin-right: -8px;
            margin-left: -8px;
        }
    }
    
    ${CheckboxGroupBox} {
        margin-top: 16px;
        width: 33%;
        padding-right: 8px;
        padding-left: 8px;
        
        ${CheckboxGroupLabel} {
            height: 100%;
            min-width: 80px;
            padding: 16px 0;
            
            ${CheckboxLabelTitle} {
                margin-top: 4px;
            }
        }
    }
`;